import { useState } from "react";
import {
  generateMenuRoutes,
  USERS,
  USER_ROLES,
  generateAccountMenuRoutes,
  generateMaintananceMenuRoutes,
  generateCommunicationMenuRoutes,
} from "../constants/constants";
import MenuItemCustom from "./MenuItemCustom";
import { GetImages } from "../utils/GetImages";
import { useMenu } from "../utils/context/MenuContext";
import { usePermissions } from "../hooks/usePermissions";
import "./CustomMenuStyles.css";

type Values = {
  noOfUnits: string;
  noOfTenants: string;
  noOfProperties: string;
  noOfServiceRequests: string;
  noOfUsers: string;
  noOfContractors: string;
};

const CustomMenu = ({ size, userRoleId }) => {
  const { isOpen, isHidden, setIsOpen, setIsHidden } = useMenu();
  const [values, setValues] = useState<Values>({
    noOfUnits: "",
    noOfTenants: "",
    noOfProperties: "",
    noOfServiceRequests: "",
    noOfUsers: "",
    noOfContractors: "",
  });

  const { hasAccess } = usePermissions();

  const filterRoutes = (routes: any[]) => {
    if (!routes) return null;
    return routes.filter((route) => {
      if (!route.permission) return true;
      return hasAccess(route.permission, 1);
    });
  };

  const menuRoutes = filterRoutes(generateMenuRoutes(values, userRoleId));
  const accountMenuRoutes = filterRoutes(
    generateAccountMenuRoutes(values, userRoleId),
  );
  const maintananceMenuRoutes = filterRoutes(
    generateMaintananceMenuRoutes(values, userRoleId),
  );
  const communicationRoutes = filterRoutes(
    generateCommunicationMenuRoutes(values, userRoleId),
  );

  return (
    <>
      <div className="sidebarMenuContainer pb-2">
        <div
          className="sidebarToggleCenter mainBackground"
          onClick={() => {
            if (size < 400) {
              setIsHidden(true);
              setIsOpen(!isOpen);
            } else {
              setIsOpen(!isOpen);
            }
          }}
        >
          <img
            src={
              isOpen ? GetImages.BlackChevronLeft : GetImages.BlackChevronRight
            }
            alt="toggle"
          />
        </div>
        <div className="sidebarMenu">
          {USER_ROLES[userRoleId] === USERS.USER &&
          hasAccess("UserDashboard", 1) ? (
            <div
              className={
                isOpen
                  ? "normalClass BorderTop"
                  : "collapsedBarClass BorderTopHide"
              }
              data-title={!isOpen ? "Dashboard" : ""}
            >
              <MenuItemCustom
                primaryText="Dashboard"
                to="/"
                key={"newMenu-1"}
                className={
                  location.pathname === "/"
                    ? "menuItemLinkClassSelected normal_text"
                    : "menuItemLinkClass normal_text"
                }
                isSelected={location.pathname === "/"}
                leftIcon={GetImages.dashboardIcon}
                alt="Dashboard Icon"
              />
            </div>
          ) : null}

          <div className={isOpen ? "BorderTop" : "BorderTopHide"}>
            <p
              className="sub_text  accountHeading"
              style={{
                display:
                  isOpen && menuRoutes && menuRoutes.length > 0
                    ? "block"
                    : "none",
              }}
            >
              Leasing
            </p>
            {menuRoutes?.map((value, index) => {
              const isSelected = location.pathname.includes(value.path);

              return (
                <div
                  key={index}
                  className={isOpen ? "normalClass" : "collapsedBarClass"}
                  data-title={!isOpen ? value.primaryText : ""}
                >
                  <MenuItemCustom
                    to={value.path}
                    primaryText={value.primaryText}
                    leftIcon={!isSelected ? value.leftIcon : value.selectedIcon}
                    className={
                      isSelected
                        ? "menuItemLinkClassSelected normal_text"
                        : "menuItemLinkClass normal_text"
                    }
                    isSelected={isSelected}
                    alt={value.primaryText}
                  />
                </div>
              );
            })}
          </div>

          <div className={isOpen ? "BorderTop" : "BorderTopHide"}>
            <p
              className="sub_text  accountHeading"
              style={{
                display:
                  isOpen &&
                  maintananceMenuRoutes &&
                  maintananceMenuRoutes.length > 0
                    ? "block"
                    : "none",
              }}
            >
              Maintenance
            </p>
            {maintananceMenuRoutes?.map((value, index) => {
              const isSelected = location.pathname.includes(value.path);

              return (
                <div
                  key={index}
                  className={isOpen ? "normalClass" : "collapsedBarClass"}
                  data-title={!isOpen ? value.primaryText : ""}
                >
                  <MenuItemCustom
                    to={value.path}
                    primaryText={value.primaryText}
                    leftIcon={!isSelected ? value.leftIcon : value.selectedIcon}
                    className={
                      isSelected
                        ? "menuItemLinkClassSelected normal_text"
                        : "menuItemLinkClass normal_text"
                    }
                    isSelected={isSelected}
                    alt={value.primaryText}
                  />
                </div>
              );
            })}
          </div>

          <div className={isOpen ? "BorderTop mb-2" : "BorderTopHide"}>
            <p
              className="sub_text  accountHeading"
              style={{
                display:
                  isOpen && accountMenuRoutes && accountMenuRoutes.length > 0
                    ? "block"
                    : "none",
              }}
            >
              Accounts
            </p>
            {accountMenuRoutes?.map((value, index) => {
              const isSelected = location.pathname.includes(value.path);

              return (
                <div
                  key={index}
                  className={isOpen ? "normalClass" : "collapsedBarClass"}
                  data-title={!isOpen ? value.primaryText : ""}
                >
                  <MenuItemCustom
                    to={value.path}
                    primaryText={value.primaryText}
                    leftIcon={!isSelected ? value.leftIcon : value.selectedIcon}
                    className={
                      isSelected
                        ? "menuItemLinkClassSelected normal_text"
                        : "menuItemLinkClass normal_text"
                    }
                    isSelected={isSelected}
                    alt={value.primaryText}
                  />
                </div>
              );
            })}
          </div>

          <div className={isOpen ? "BorderTop mb-2" : "BorderTopHide"}>
            <p
              className="sub_text  accountHeading"
              style={{
                display:
                  isOpen &&
                  communicationRoutes &&
                  communicationRoutes.length > 0
                    ? "block"
                    : "none",
              }}
            >
              Communication
            </p>
            {communicationRoutes?.map((value, index) => {
              const isSelected = location.pathname.includes(value.path);

              return (
                <div
                  key={index}
                  className={isOpen ? "normalClass" : "collapsedBarClass"}
                  data-title={!isOpen ? value.primaryText : ""}
                >
                  <MenuItemCustom
                    to={value.path}
                    primaryText={value.primaryText}
                    leftIcon={!isSelected ? value.leftIcon : value.selectedIcon}
                    className={
                      isSelected
                        ? "menuItemLinkClassSelected normal_text"
                        : "menuItemLinkClass normal_text"
                    }
                    isSelected={isSelected}
                    alt={value.primaryText}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomMenu;
